module.exports = __webpack_public_path__ + "img/company_logo_white.ae1bc768.png";